import { css, extractTransition, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  menu: css`
    z-index: 3;
    width: 235px;
  `,
  tooltip: css`
    display: flex;
    flex-shrink: 0;
    & > div:first-of-type {
      width: 100%;
    }
  `,
  inputWidthEn: css`
    max-width: 156px;
  `,
  inputWidthNl: css``,
  input: ({ theme }) => css`
    color: ${theme.colors.secondary.sky[60]};
    border-color: ${theme.colors.secondary.sky[10]};
    background-color: ${theme.colors.secondary.sky[10]};

    ${extractTransition((f) => f.cubic, {
      duration: 220,
      property: ['color', 'border-color', 'background-color', 'width', 'max-width'],
    })}

    &:hover {
      border-color: ${theme.colors.secondary.sky[20]};
      background-color: ${theme.colors.secondary.sky[20]};
    }
  `,
  inputOpen: ({ theme }) => css`
    &,
    &:hover,
    &:focus,
    &:focus-within {
      max-width: 250px;

      color: ${theme.colors.neutral.variant[80]};

      border-color: ${theme.colors.primary.fuchsia[30]};
      background-color: white;
    }
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
